import React from 'react';
import { RootState } from 'redux/root.reducer';
import { CFCProps } from 'types';
import {
  ModalFooter,
  ComposedModal,
  ModalHeader,
  ModalBody,
  Button
} from 'carbon-components-react';
import { connect } from 'react-redux';
import PreviewContent from './content';
import { CloudDownload16 } from '@carbon/icons-react';
import { getEmailAttachment } from 'utilities/helper.util';

export const PreviewModal: React.FC<Props> = ({ email, onClose }) => {
  return (
    <div className="ao-emails-history search-emails-preview-emails">
      <ComposedModal open={email !== undefined} onClose={() => onClose()}>
        <ModalHeader label="Preview email">
          {email.subject}
          <div className="search-emails-display-attachments">
            {email?.Attachments?.filter(
              (item: any) => item.mimeType !== 'message/rfc822'
            ).map((attachment: any) => {
              return (
                <Button
                  key={attachment.id}
                  kind="tertiary"
                  size="field"
                  renderIcon={CloudDownload16}
                  onClick={() =>
                    getEmailAttachment({
                      url: attachment.url,
                      attachmentName: attachment.name
                    })
                  }
                >
                  {attachment.name}
                </Button>
              );
            })}
          </div>
        </ModalHeader>
        <ModalBody>
          <PreviewContent email={email} />
        </ModalBody>
        <ModalFooter primaryButtonText="Close" onClick={() => onClose()} />
      </ComposedModal>
    </div>
  );
};

const mapStateToProps = ({ emailCache }: RootState) => ({
  email: emailCache.emailPreview
});

const connector = connect(mapStateToProps);

type OwnProps = {
  onClose: Function;
};

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(PreviewModal));
